import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_2 = { class: "text-sm capitalize" }
const _hoisted_3 = ["required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1),
    _withDirectives(_createElementVNode("input", {
      type: "date",
      class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
      required: _ctx.required
    }, null, 40, _hoisted_3), [
      [_vModelText, _ctx.inputValue]
    ])
  ]))
}